// extracted by mini-css-extract-plugin
export default {"header":"admin_item_page-module___header___fff659a8"};